module.exports = __webpack_public_path__ + "static/media/in.2be01d63.svg";